import React, { useEffect, useRef, useState } from "react";

// Masked line-by-line reveal implemented with CSS keyframes.
// Reliable across React 19 + framer-motion peculiarities.

function LineSpan({ children, delay, playing = true }) {
  const style = {
    animationDelay: `${delay}s`,
    animationPlayState: playing ? "running" : "paused",
  };
  return (
    <span className="line-mask">
      <span style={style}>{children}</span>
    </span>
  );
}

// Immediate on-load reveal
export function RevealTextInstant({
  lines,
  as: Tag = "h1",
  className = "",
  delay = 0.15,
  stagger = 0.09,
}) {
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <LineSpan key={i} delay={delay + i * stagger}>
          {line}
        </LineSpan>
      ))}
    </Tag>
  );
}

// Scroll-triggered reveal (uses IntersectionObserver)
export default function RevealText({
  lines,
  as: Tag = "h1",
  className = "",
  delay = 0,
  stagger = 0.08,
  once = true,
}) {
  const ref = useRef(null);
  const [play, setPlay] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setPlay(true);
          if (once) io.disconnect();
        } else if (!once) {
          setPlay(false);
        }
      });
    }, { threshold: 0.1, rootMargin: "-5% 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [once]);

  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <LineSpan key={i} delay={delay + i * stagger} playing={play}>
          {line}
        </LineSpan>
      ))}
    </Tag>
  );
}
